import { ThemePalette } from "@angular/material/core";
import { MatFormFieldAppearance } from "@angular/material/form-field";
import { Component, inject, input } from "@angular/core";
import { ControlContainer, ControlValueAccessor, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  template: ``,
})
export abstract class ReactiveFormsBaseComponent implements ControlValueAccessor {
  private controlContainer = inject(ControlContainer);

  readonly color = input<ThemePalette>("primary");
  readonly appearance = input<MatFormFieldAppearance>("outline");
  readonly formControlName = input.required<string>();

  get form() {
    return this.controlContainer.control as FormGroup;
  }

  get control() {
    return this.form.get(this.formControlName()) as FormControl;
  }

  get value() {
    if (!this.control) return null;

    return this.control.value;
  }

  get isRequired() {
    if (!this.control) return false;
    return this.control.hasValidator(Validators.required);
  }

  get isDisabled() {
    if (!this.control) return false;
    return this.control.disabled;
  }

  onChange: (_: unknown) => void = () => {};
  onTouched: (_: unknown) => void = () => {};

  writeValue(_: unknown): void {}

  registerOnChange(fn: (_: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (_: unknown) => void): void {
    this.onTouched = fn;
  }
}
